// path: src/utils/gid.js
// Game Identity (GID): unique 8-digit codes with no leading zeros.

export const GID_MIN = 10000000;
export const GID_MAX = 99999999;

export function isValidGid(value) {
    const n = Number(value);
    return Number.isInteger(n) && n >= GID_MIN && n <= GID_MAX;
}

export function formatGid(value) {
    if (!isValidGid(value)) {
        return "";
    }

    return String(Number(value));
}

export function parseGidInput(raw) {
    if (raw === null || raw === undefined) {
        return null;
    }

    const digits = String(raw).replace(/\D/g, "");
    if (digits.length !== 8) {
        return null;
    }

    const n = Number(digits);
    return isValidGid(n) ? n : null;
}

export function randomGidCandidate(randomFn = Math.random) {
    const span = GID_MAX - GID_MIN + 1;
    return GID_MIN + Math.floor(randomFn() * span);
}
